import {
  GET_SUPPORTING_APPLICATION_API,
  IMPORT_SUPPORTING_APPLICATION_API,
  OBSOLETE_SUPPORTING_APPLICATION_API,
  SEARCH_SUPPORTING_APPLICATIONS_API
} from '~/constants/APIs'
import {
  IObsoleteSupportingApplicationRequest,
  ISupportingApplicationDetails,
  ISupportingApplicationSearchRequest,
  ISupportingApplicationSearchResponse
} from '~/models'
import axiosClient from './axiosClient'

export const supportingApplicationApis = {
  searchSupportingApplications: (params: ISupportingApplicationSearchRequest | {}) =>
    axiosClient.get(SEARCH_SUPPORTING_APPLICATIONS_API, {
      params
    }) as unknown as ISupportingApplicationSearchResponse,

  getSupportingApplication: (id: string | undefined) =>
    axiosClient.get(
      GET_SUPPORTING_APPLICATION_API + id
    ) as unknown as ISupportingApplicationDetails,

  importSupportingApplication: (data: File[]) => {
    const formData = new FormData()
    data.forEach(item => formData.append('formFiles', item))
    return axiosClient.post(IMPORT_SUPPORTING_APPLICATION_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  obsolete: (data: IObsoleteSupportingApplicationRequest) =>
    axiosClient.post(OBSOLETE_SUPPORTING_APPLICATION_API, data)
}
